import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { apiPost } from '../../api';
import { resetPasswordStart, resetPasswordSuccess, resetPasswordFailure } from '../../slices/authSlice';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';

const ResetPassword = () => {
  const dispatch = useDispatch();
  const { loading } = useSelector((state) => state.auth);
  const [email, setEmail] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(resetPasswordStart());
    try {
      const res = await apiPost('/api/admin/auth/reset-password', { email });
      dispatch(resetPasswordSuccess(res.data));
      toast.success(res.data.message || 'Check your email for new password');
    } catch (err) {
      const msg = err.response?.data?.message || 'Reset failed';
      dispatch(resetPasswordFailure(msg));
      toast.error(msg);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <div className="flex items-center justify-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em] text-muted-foreground mb-2">
            <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
            Admin
            <span className="h-px w-6 bg-ginox-green" aria-hidden="true" />
          </div>
          <h1 className="font-serif italic text-[32px] leading-[1.02] text-foreground mb-1">Reset <span className="text-gradient-ginox">Password</span></h1>
          <p className="text-sm text-muted-foreground">Enter your email to receive a new password</p>
        </div>

        <div className="rounded-xl border border-border/70 bg-card p-6 shadow-xl">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium uppercase tracking-[0.06em] text-muted-foreground mb-1.5">
                Email
              </label>
              <div className="relative">
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground/50" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  placeholder="admin@ginox.com"
                  className="w-full rounded-md border border-border/70 bg-white/[0.03] pl-9 pr-3 py-2 text-sm text-foreground placeholder:text-muted-foreground/50 focus:border-ginox-green/50 focus:outline-none focus:ring-1 focus:ring-ginox-green/30"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full rounded-md border border-ginox-green/60 bg-ginox-green/10 py-2.5 text-sm font-medium text-ginox-green hover:bg-ginox-green/20 transition-colors disabled:opacity-40"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
          </form>
        </div>

        <div className="mt-4 text-center">
          <Link
            to="/auth/login"
            className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors"
          >
            <ArrowLeft className="h-3.5 w-3.5" />
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
